/*
 * This file gets bundled and placed in `/build/assets` along with it's assets
 */
import 'normalize.css'
import '@app/styles/fonts.css'
import '@app/styles/globals.scss'
